// 引入文件
import index from './actions/index'

export default {
    ...index
}


// WEBPACK FOOTER //
// ./src/store/actions.js